export const SET_INTERVIEWER = 'SET_INTERVIEWER';
export const SET_ERRORS = 'SET_ERRORS';
